import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-6 pb-4 md:pt-32 md:pb-24 overflow-hidden bg-[#0B1426]" data-id="element-101">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-blue-600/10 blur-[120px] rounded-full pointer-events-none" data-id="element-102"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-104">
          <span className="inline-block py-0.5 px-2 rounded-full bg-blue-500/10 text-blue-400 text-[10px] md:text-sm font-bold tracking-wider mb-2 md:mb-6 border border-blue-500/20" data-id="element-105">
            PARA NEURÓLOGOS Y PSIQUIATRAS QUE ATIENDEN TDAH Y TEA
          </span>

          <h1 className="text-[22px] leading-tight md:text-5xl lg:text-6xl font-extrabold text-white mb-2 md:mb-8" data-id="element-106">
            DEJÁ DE TERMINAR EL DÍA AGOTADO HACIENDO EL{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600" data-id="element-107">
              TRABAJO QUE NADIE TE PAGA.
            </span>
          </h1>

          <p className="text-sm md:text-xl text-gray-300 mb-3 md:mb-10 max-w-3xl mx-auto leading-snug md:leading-relaxed" data-id="element-108">
            El primer sistema clínico que te da todo el material listo para
            usar, automatiza tu burocracia con prepagas y le demuestra a las
            familias —con datos reales— el avance de sus pacientes.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative mx-auto max-w-2xl mb-3 md:mb-12 cursor-pointer group" onClick={scrollToPricing} data-id="element-109">
          <div className="absolute -inset-1 bg-gradient-to-r from-blue-500 to-blue-700 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-500" data-id="element-110"></div>
          <img src="https://cdn.magicpatterns.com/uploads/cuRUXT1LLyJoTS7b8ZBUPZ/heylloyd-image-1773505866622-removebg-preview.png" alt="Mega Kit Neuro-Pro" className="relative w-full max-w-[200px] md:max-w-lg mx-auto object-contain drop-shadow-2xl transition-transform duration-500 group-hover:scale-105" data-id="element-111" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-112">
          <div className="bg-[#111827] border border-gray-800 rounded-xl p-3 md:p-6 mb-3 md:mb-8 max-w-2xl w-full shadow-lg" data-id="element-113">
            <h3 className="text-base md:text-xl font-bold text-white mb-2 md:mb-4" data-id="element-114">
              MEGA KIT NEURO-PRO
            </h3>
            <ul className="text-gray-300 space-y-1 md:space-y-2 text-xs md:text-base text-left md:text-center" data-id="element-115">
              <li className="flex items-center justify-center gap-1.5 md:gap-2" data-id="element-116">
                <span className="text-yellow-500" data-id="element-117">✓</span> Plantillas de
                Informes Anti-Rebote para CUD y Prepagas.
              </li>
              <li className="flex items-center justify-center gap-1.5 md:gap-2" data-id="element-118">
                <span className="text-yellow-500" data-id="element-119">✓</span> Batería de Screening
                In-Situ para TDAH y TEA.
              </li>
              <li className="flex items-center justify-center gap-1.5 md:gap-2" data-id="element-120">
                <span className="text-yellow-500" data-id="element-121">✓</span> Sistema de Retención
                y Seguimiento para Familias.
              </li>
            </ul>
            <p className="mt-2 md:mt-4 font-medium text-yellow-400 text-xs md:text-base" data-id="element-122">
              Descargás. Imprimís. Recuperás tu tiempo.
            </p>
          </div>

          <CTAButton text="ACCEDER AL MEGA KIT NEURO-PRO AHORA" className="w-full md:w-auto !py-3 !px-5 !text-sm md:!text-xl md:!py-4 md:!px-8" data-id="element-123" />
          <p className="mt-2 md:mt-4 text-[11px] md:text-sm text-gray-400" data-id="element-124">
            Pago único de $19.990 ARS · Acceso inmediato
          </p>
        </motion.div>
      </div>
    </section>;
}